<template>
	<div class="setting-page">
			<div class="ft20 cl-main ftw600">门店列表</div>
			
			<div class="form-search-box mt20">
				<a-form layout="inline">
					<a-form-item label="门店名称">
						<a-input v-model="search.keyword" placeholder="请输入门店名称"></a-input>
					</a-form-item>
					
				
					<a-form-item>
						<a-button @click="searchAct" type="primary">查询</a-button>
						<a-button @click="cancelAct" class="ml10">取消</a-button>
					</a-form-item>
				</a-form>
			</div>
			
			<div  class="mt20">
				<a-button type="primary"  @click="addAct">新增门店</a-button>
			</div>
			<div class="mt20">
					<div class="wxb-table-white">
						<a-table rowKey="mendian_id" :columns="columns" :pagination="pagination" @change="handleTableChange" :data-source="datas"
						 :loading="loading">
						<template slot="pois" slot-scope="record,index">
							<div>
								{{record.lat}}/{{record.lng}}
							</div>
						</template>
						<template slot="action" slot-scope="record,index">
							<div class="flex center">
								<a-dropdown placement="bottomRight">
									<span class="more-act">
										<i class="iconfont iconmore_gray"></i>
									</span>
									<a-menu slot="overlay">
										<a-menu-item>
											<a class="menu-act" href="javascript:;" @click="editAct(record)">
												<span>编辑门店</span>
											</a>
										</a-menu-item>
										
										<a-menu-item>
											<a class="menu-act" href="javascript:;" @click="delAct(record)">
												<span>删除门店</span>
											</a>
										</a-menu-item>
									
									</a-menu>
								</a-dropdown>
							</div>
						</template>
						</a-table>
					</div>
				</div>
			
			<div>
				<mendian-form v-if="showForm" @ok="formOk" @closed="formClosed" :datas="detail"></mendian-form>
			</div>
			
	</div>
</template>

<script>
import {
		listMixin
	} from '../../common/mixin/list.js';
	import mendianForm from './components/mendian/form.vue';
	
	export default{
		mixins: [listMixin],
		components:{
			mendianForm
		},
		computed:{
			checkCanAdd(){
				return  this.maxOpenNum > this.pagination.total;
			}
		},
		data(){
			return {
				loading: false,
				showForm:false,
				detail:{
					mendian_id:0,
					name:'',
					tel:'',
					lng:'',
					lat:'',
					address:'',
				},
				pagination: {
					current: 1,
					pageSize: 10, //每页中显示10条数据
					total: 0,
				},
				search: {
					keyword:'',
				},
				maxOpenNum:0,
				columns: [
					{title: '门店ID',dataIndex: 'mendian_id',align: 'center'},
					{title: '门店名称',dataIndex: 'name',align: 'center'},
					{title: '门店地址',dataIndex: 'address',align: 'center'},
					{title: '门店电话',dataIndex: 'tel',align: 'center'},
					{title: '地理坐标',key: 'pois',align: 'center',scopedSlots: {customRender: 'pois'}},
					{title: '操作',key: 'action',align: 'center',scopedSlots: {customRender: 'action'}},
				],
				datas: [],
			}
		},
		created(){
			this.getLists();
			//做你要做的事情 
			
		},
		methods:{
			
			addAct(){
				/*if(this.checkCanAdd){
					this.detail = {
						mendian_id:0,
						name:'',
						tel:'',
						lng:'',
						lat:'',
						address:'',
					}
					this.showForm = true;
				}else{
					this.$error({
					        title: '错误提示',
					        content: '您可最多可创建'+this.maxOpenNum+'个门店',
					});
				}*/
				this.detail = {
					mendian_id:0,
					name:'',
					tel:'',
					lng:'',
					lat:'',
					address:'',
				}
				this.showForm = true;
				
			},
			editAct(res){
				this.detail = res;
				this.showForm = true;
			},
			formOk(){
				this.showForm = false;
				this.getLists();
			},
			formClosed(){
				this.showForm = false;
			},
			delAct(record){
				this.$confirm({
					title:'确认删除这个门店吗？',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('admin/delMendian',{
								mendian_id:record.mendian_id,
							}).then(res=>{
								this.$message.success('删除成功');
								this.getLists();
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				})
			},
			getLists(){
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('admin/getMendianList',{
					keyword:this.search.keyword,
					limit:this.pagination.pageSize,
					page:this.pagination.current,
				}).then(res=>{
					this.pagination.total=res.total;
					this.datas=res.list;
					this.maxOpenNum = res.store_num;
					this.loading=false;
				}).catch(res=>{
					console.log(res);
					this.loading=false;
				})
			},
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current;
				this.getLists();
			},
			searchCancel() {
				this.search = {
					keyword:'',
				};
			},
			searchAct(){
				this.getLists();
			},
			cancelAct(){
				this.searchCancel();
				this.searchAct();
			}
		
		}
	}
</script>

<style>
	.setting-page{
		min-width: 1080px;
	}
</style>